export default __webpack_public_path__ + "static/media/PS.b58afafb.svg";